import { ROLES } from '../../constants/roles';
import { PHARMACY_COPY } from './pharmacyCopy';

export const CENTRAL_PHARMACY_BASE = '/pharmacy-central';
export const PHARMACIST_BASE = '/pharmacist';

export const CENTRAL_PHARMACY_PATHS = {
  DASHBOARD: CENTRAL_PHARMACY_BASE,
  CATALOG: `${CENTRAL_PHARMACY_BASE}/catalogue`,
  CENTRAL_STOCK: `${CENTRAL_PHARMACY_BASE}/stock-central`,
  DUTY_CABINET: `${CENTRAL_PHARMACY_BASE}/armoire-garde`,
  SITE_STOCKS: `${CENTRAL_PHARMACY_BASE}/stocks-sites`,
  SUPPLIERS: `${CENTRAL_PHARMACY_BASE}/fournisseurs`,
  ORDERS: `${CENTRAL_PHARMACY_BASE}/commandes`,
  ORDER_NEW: `${CENTRAL_PHARMACY_BASE}/commandes/nouvelle`,
  ORDER_DETAIL: (id) => `${CENTRAL_PHARMACY_BASE}/commandes/${id}`,
  REQUESTS: `${CENTRAL_PHARMACY_BASE}/demandes`,
  DISTRIBUTIONS: `${CENTRAL_PHARMACY_BASE}/distributions`,
  DISTRIBUTION_NEW: `${CENTRAL_PHARMACY_BASE}/distributions/nouvelle`,
  DISTRIBUTION_DETAIL: (id) => `${CENTRAL_PHARMACY_BASE}/distributions/${id}`,
  DISPENSATIONS: `${CENTRAL_PHARMACY_BASE}/dispensation`,
  DISPENSATION_NEW: `${CENTRAL_PHARMACY_BASE}/dispensation/nouvelle`,
  DISPENSATION_DETAIL: (id) => `${CENTRAL_PHARMACY_BASE}/dispensation/${id}`,
  INTERACTIONS: `${CENTRAL_PHARMACY_BASE}/interactions`,
  ALERTS: `${CENTRAL_PHARMACY_BASE}/alertes`,
  MOVEMENTS: `${CENTRAL_PHARMACY_BASE}/mouvements`,
  INVENTORIES: `${CENTRAL_PHARMACY_BASE}/inventaire`,
  INVENTORY_DETAIL: (id) => `${CENTRAL_PHARMACY_BASE}/inventaire/${id}`,
  REPORTS: `${CENTRAL_PHARMACY_BASE}/rapports`
};

export const PHARMACIST_PATHS = {
  DASHBOARD: PHARMACIST_BASE,
  SITE_STOCKS: `${PHARMACIST_BASE}/stocks-sites`,
  REQUESTS: `${PHARMACIST_BASE}/demandes`,
  DISPENSATIONS: `${PHARMACIST_BASE}/dispensation`,
  DISPENSATION_NEW: `${PHARMACIST_BASE}/dispensation/nouvelle`,
  DISPENSATION_DETAIL: (id) => `${PHARMACIST_BASE}/dispensation/${id}`,
  ALERTS: `${PHARMACIST_BASE}/alertes`,
  INVENTORIES: `${PHARMACIST_BASE}/inventaire`,
  INVENTORY_DETAIL: (id) => `${PHARMACIST_BASE}/inventaire/${id}`,
  MOVEMENTS: `${PHARMACIST_BASE}/mouvements`
};

const { NAV } = PHARMACY_COPY;

export const CENTRAL_PHARMACY_NAV_ITEMS = [
  { to: CENTRAL_PHARMACY_PATHS.DASHBOARD, end: true, ...NAV.dashboard },
  { to: CENTRAL_PHARMACY_PATHS.CATALOG, ...NAV.catalog },
  { to: CENTRAL_PHARMACY_PATHS.CENTRAL_STOCK, ...NAV.centralStock },
  { to: CENTRAL_PHARMACY_PATHS.DUTY_CABINET, ...NAV.dutyCabinet },
  { to: CENTRAL_PHARMACY_PATHS.SITE_STOCKS, ...NAV.siteStocks },
  { to: CENTRAL_PHARMACY_PATHS.INVENTORIES, ...NAV.inventories },
  { to: CENTRAL_PHARMACY_PATHS.SUPPLIERS, ...NAV.suppliers },
  { to: CENTRAL_PHARMACY_PATHS.ORDERS, ...NAV.orders },
  { to: CENTRAL_PHARMACY_PATHS.REQUESTS, ...NAV.requests },
  { to: CENTRAL_PHARMACY_PATHS.DISTRIBUTIONS, ...NAV.distributions },
  { to: CENTRAL_PHARMACY_PATHS.DISPENSATIONS, ...NAV.dispensations },
  { to: CENTRAL_PHARMACY_PATHS.INTERACTIONS, ...NAV.interactions },
  { to: CENTRAL_PHARMACY_PATHS.ALERTS, ...NAV.alerts },
  { to: CENTRAL_PHARMACY_PATHS.MOVEMENTS, ...NAV.movements },
  { to: CENTRAL_PHARMACY_PATHS.REPORTS, ...NAV.reports }
];

export const PHARMACIST_NAV_ITEMS = [
  { to: PHARMACIST_PATHS.DASHBOARD, end: true, ...NAV.dashboard },
  { to: PHARMACIST_PATHS.SITE_STOCKS, ...NAV.workSiteStock },
  { to: PHARMACIST_PATHS.INVENTORIES, ...NAV.inventories },
  { to: PHARMACIST_PATHS.REQUESTS, ...NAV.requests },
  { to: PHARMACIST_PATHS.DISPENSATIONS, ...NAV.dispensations },
  { to: PHARMACIST_PATHS.ALERTS, ...NAV.alerts },
  { to: PHARMACIST_PATHS.MOVEMENTS, ...NAV.movements }
];

export function centralNavItemsForRole(role) {
  if (![ROLES.ADMIN, ROLES.ADMIN_PHARMACIST].includes(role)) return [];
  return CENTRAL_PHARMACY_NAV_ITEMS;
}

export function pharmacistNavItemsForRole(role) {
  if (![ROLES.PHARMACIST].includes(role)) return [];
  return PHARMACIST_NAV_ITEMS;
}
